<template>
  <tr>
    <td data-label="Finding">
      <div class="d-sm-none">
        <br/>
        <p class="text-left mb-0 mt-2">
          {{ ohsFinding.finding }}
        </p>
      </div>
      <span class="d-none d-sm-block">
        {{ ohsFinding.finding }}
      </span>
    </td>
    <td data-label="Recommendation">
      <div class="d-sm-none">
        <br/>
        <p class="text-left mb-0 mt-2">
          {{ ohsFinding.recommendation }}
        </p>
      </div>
      <span class="d-none d-sm-block">
        {{ ohsFinding.recommendation }}
      </span>
    </td>
    <td class="button-2 text-center">
      <button class="my-2 btn btn-warning" @click="editFinding()">
        <i class="fa fa-edit" /> Edit
      </button>
      <button class="my-2 btn btn-danger" @click="deleteFinding()">
        <i class="fa fa-trash" /> Delete
      </button>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'OhsFindingRow',
    props: {
      object: {
        type: Object
      },
      index: {
        type: Number
      }
    },
    computed: {
      ohsFinding () {
        return {
          ...this.object
        }
      }
    },
    methods: {
      editFinding () {
        this.$emit('edit', { permalink: 'editOhsFinding', uuid: this.ohsFinding.uuid })
      },
      deleteFinding () {
        this.$emit('deleteObject', { permalink: 'deleteOhsFinding', uuid: this.ohsFinding.uuid })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/rows/OhsFinding.vue